import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=647ba36a&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ba36a",
  null
  
)

export default component.exports